import { searchPharmacies } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  PharmacyPagedListResponseT,
  SearchPharmaciesParams,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export interface SearchPharmaciesInput extends SearchPharmaciesParams {
  specialty?: string[];
}

export async function fetchSearchPharmacies(
  input: SearchPharmaciesInput,
  signal?: AbortSignal
): Promise<PharmacyPagedListResponseT> {
  const { specialty, ...params } = input;
  const config = await createLotusRequestConfig({ signal });
  const response = await searchPharmacies(specialty ?? null, params, config);
  return lotusHealthZod.searchPharmaciesResponse.parse(response.data) as PharmacyPagedListResponseT;
}
